import { Component, Story, Knobs } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  type: {
    default: 'danger',
    editor: 'dropdown',
    editorOptions: ['danger', 'warning', 'information'],
  },
};

const Playground: Story = {
  title: 'Playground',
  description: 'A simple input element with various attributes',
  coreComponent_v3: {
    html: `<tag3-input></tag3-input>
  <tag3-validation-alert-inline{{...knobs}}><div>Error</div></tag3-validation-alert-inline>`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper_v3: {
    jsx: `<div>
  <Tag3Input></Tag3Input>
  <Tag3ValidationAlertInline{{...knobs}}><div>Error</div></Tag3ValidationAlertInline>
</div>`,
    knobs: PlaygroundKnobs,
  },
};

export const TagValidationAlertInlineDocs: Component = {
  type: 'component',
  name: 'validation-alert-inline',
  description: 'Renders an inline validation alert element',
  mobileFriendly: true,
  popular: true,
  preRelease: '',
  props: [
    {
      name: 'type',
      description: 'The type of the input',
      type: "'danger' | 'warning' | 'information'",
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [Playground],
};
